export default class TweensColorPicker
{
    constructor(scene)
    {
        this.scene = scene;
    }

    PlateIn(Plate)
    {
        this.scene.playSound("plate_tween");
        this.scene.addTween(Plate, 300, {x: {start: Plate.x+800, to: Plate.x}},Phaser.Math.Easing.Quadratic.InOut)
    }

    FallingInTween(Cake, Array)
    {
        //const Fall = this.scene.playSound("cake_impact");
        //Fall.setSeek(2.13);
        this.scene.addTween(Cake, 900, {y:{start: Cake.y - 1800, to: Cake.y},Delay:170}, Phaser.Math.Easing.Quadratic.In,()=>
        {
            this.scene.playSound("cake_impact");
            this.TintButtonsIn(Array);
            this.scene.addTween(Cake, 100, {scaleY: .9}, Phaser.Math.Easing.Linear);
            this.scene.addTween(Cake, 100, {scaleX: 1.1}, Phaser.Math.Easing.Linear,()=>
            {
                this.scene.addTween(Cake, 100, {scaleY: {start: .9, to: 1}}, Phaser.Math.Easing.Linear);
                this.scene.addTween(Cake, 100, {scaleX: {start: 1.1, to: 1}}, Phaser.Math.Easing.Linear,()=>
                {
                    this.scene.addTween(Cake, 100, {scaleY: {start:1, to:.95}}, Phaser.Math.Easing.Linear);
                    this.scene.addTween(Cake, 100, {scaleX:{start:1, to:1.05}}, Phaser.Math.Easing.Linear,()=>
                    {
                        this.scene.addTween(Cake, 100, {scaleY: {start: .95, to:1}}, Phaser.Math.Easing.Linear);
                        this.scene.addTween(Cake, 100, {scaleX: {start:1.05, to:1}}, Phaser.Math.Easing.Linear);
                    });
                });
            });
        });
    }

    TintButtonsIn(Array)
    {
        //console.log(this.scene.playSound("colors_tween"));
        // const Pop = this.scene.playSound("button_menu_click",.3);
        // Pop.pause();
        // Pop.setDetune(800);
        // Pop.setRate(1.5);
        // console.log(Pop);
        //this.scene.addDelay(93,()=>{
        this.scene.playSound("colors_tween");
        //});
        for(let i = 0; i < 10; i++)
        {
            this.scene.addTween(Array[i], 730,{scale:1,delay:i * 50},Phaser.Math.Easing.Elastic.InOut);
            this.scene.addTween(Array[19-i], 730,{scale:1,delay:i * 50},Phaser.Math.Easing.Elastic.InOut);
  
        }
    }

    TintButtonsOut(Array)
    {
        // const Pop = this.scene.playSound("button_menu_click",.3);
        // Pop.pause();
        // Pop.setDetune(800);
        // Pop.setRate(1.5);
        // console.log(Pop);
        
        this.scene.addDelay(5,()=>{
            this.scene.playSound("color_tweens_out");
        });
        for(let i = 0; i < 10; i++)
        {
            this.scene.addTween(Array[9-i], 770,{scale:0,delay:i * 50},Phaser.Math.Easing.Elastic.InOut);
            this.scene.addTween(Array[10+i], 770,{scale:0,delay:i * 50},Phaser.Math.Easing.Elastic.InOut);
            // this.scene.addDelay(50 * i,()=>{
            //     this.scene.addDelay(580,()=>{
            //     Pop.play('button_menu_click');
            //     });
            // });    
        }
    }

    InstructionsIn(Instruct)
    {
        let Tween = this.scene.addTween(Instruct, 800,{y:{start: Instruct.y - 200, to:Instruct.y}},Phaser.Math.Easing.Bounce.Out);
        Tween.once('start', ()=>
        {
            Instruct.setVisible(true);
        });
    }

    InstructionsOut(Instruct)
    {
        let Tween = this.scene.addTween(Instruct, 800,{y:Instruct.y - 200},Phaser.Math.Easing.Linear);
    }

    NextButtonIn(Next)
    {
        let Tween = this.scene.addTween(Next, 800,{x:{start: Next.x + 200, to:Next.x}},Phaser.Math.Easing.Bounce.Out);
        Tween.once('start', ()=>
        {
            Next.setVisible(true);
        });
    }

    NextButtonOut(Next)
    {
        let Tween = this.scene.addTween(Next, 900,{x:Next.x + 200},Phaser.Math.Easing.Quadratic.InOut);
        Tween.once('complete', ()=>
        {
            this.scene.scene.start("PlaceItems");
        });
    }

}